module.exports = __webpack_public_path__ + "static/abstract_pattern-2fab4d9b72acb6d77ea8956247cc40dc.png";